// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1tjTK","content":"RecentSearches_content__3qfBI"};